import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-header-component',
  templateUrl: './header-component.component.html',
  styleUrls: ['./header-component.component.scss']
})
export class HeaderComponentComponent implements OnInit {

  @Input() title:any;
  @Input() title2:any;
  @Input() description:any;
  @Input() description1:any;
  @Input() description2:any;
  @Input() entities : any = [];
  @Input() urlRepository:any;

  highlighted: boolean = false;

  public idTitle = '';
  private _titleService!: Title;

  entitiesList: any = environment.urlEntitiesList;

  constructor(
    private titleHeader: Title) {
  }


  ngOnInit(): void {
    const title = (this.title.toLowerCase()).replace(/ /g, '-');
    this.removeAccents(title);
    this.titleHeader.setTitle(this.title);
  }

  removeAccents(str:any): void {
    this.idTitle = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  exist(entitieName:any): boolean {
    return this.entities.find((e: any) => e === entitieName) != null;
  }
}
